import { render, staticRenderFns } from "./elementProps.vue?vue&type=template&id=7544d444&scoped=true&"
import script from "./elementProps.vue?vue&type=script&lang=js&"
export * from "./elementProps.vue?vue&type=script&lang=js&"
import style0 from "./elementProps.vue?vue&type=style&index=0&id=7544d444&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7544d444",
  null
  
)

export default component.exports